import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { Calendar } from "lucide-react";
import React, { useState, useRef } from "react";

const Circle_Date_Component = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);
  const buttonRef = useRef(null);
  return (
    <div className="">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <div className="relative">
          <button
            ref={buttonRef}
            onClick={() => setOpen(true)}
            className="flex items-center justify-center"
          >
            {value && value.isValid() ? (
              <div className="text-xs">{value.format("MMM DD, YYYY")}</div>
            ) : (
              <div className="flex justify-center items-center w-5 h-5 rounded-full border-1 border-dashed border-black">
                <Calendar size={10} />
              </div>
            )}
          </button>
        </div>
        <div
          style={{ position: "absolute", top: "100%", left: 0, zIndex: 1000 }}
        >
          <DatePicker
            value={value}
            // onChange={(newValue) => {
            //   setValue(newValue);
            //   setOpen(false);
            // }}
            onChange={onChange}
            format="MMM-DD"
            open={open}
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
            slots={{
              textField: () => null,
            }}
            slotProps={{
              popper: {
                anchorEl: buttonRef.current,
                placement: "bottom-start",
              },
              actionBar: {
                actions: ["clear"],
              },
            }}
          />
        </div>
      </LocalizationProvider>
    </div>
  );
};

export default Circle_Date_Component;
